// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2WXON","detailsBorder":"styles_detailsBorder__1R_qL"};